import request from "@/utils/request";

export const getPrettyPreviewApi = (data) =>
  request({
    url: `/api/V2/pretty-preview${data ? `?${data}` : ""}`,
    method: "get",
  });

export const createPrettyPreviewApi = (data) =>
  request({
    url: `/api/V2/pretty-preview`,
    method: "post",
    data,
  });

export const exportPrettyPreviewApi = (data) =>
  request({
    url: `/api/V2/pretty-preview/export`,
    method: "post",
    data,
    responseType: "blob",
  });

// A ZIP of everything made for a preview whose deal is closed.
export const downloadPrettyPreviewAssetsApi = (id) =>
  request({
    url: `/api/V2/pretty-preview/${id}/assets`,
    method: "get",
    responseType: "blob",
  });

export const blockPrettyPreviewApi = (data) =>
  request({
    url: `/api/V2/pretty-preview/blocking`,
    method: "post",
    data,
  });
export const unblockPrettyPreviewApi = (data) =>
  request({
    url: `/api/V2/pretty-preview/unblocking`,
    method: "post",
    data,
  });

// Takes the canvas fields from the saved record itself and answers with { hash } for the
// full-screen canvas preview page, like /api/V2/canvas/share does.
export const sharePrettyPreviewApi = (id) =>
  request({
    url: `/api/V2/pretty-preview/${id}/share`,
    method: "post",
  });

// Updates a preview request: its client fields and status, and — when the canvas was
// changed — { canvas_scene, preview_image }. Only previews no order was created from may
// be changed, agent-made and self-served alike.
export const updatePrettyPreviewApi = (id, data) =>
  request({
    url: `/api/V2/pretty-preview/${id}`,
    method: "patch",
    data,
  });

// Archived previews leave the default list but are still found by a search.
export const archivePrettyPreviewApi = (ids) =>
  request({
    url: `/api/V2/pretty-preview/archive`,
    method: "post",
    data: { ids },
  });

// Brings archived previews back to the list, for another 14 days before the auto-archive.
export const restorePrettyPreviewApi = (ids) =>
  request({
    url: `/api/V2/pretty-preview/restore`,
    method: "post",
    data: { ids },
  });
